// Group Links のアコーディオン制御をするクラス
export default class GroupLinksAccordion {
  constructor () {
    this.elements = document.querySelectorAll('.zigexn-group-accordion')
    this.init()
  }

  get OPEN_CLASS () {
    return 'open'
  }

  get TRIGGER_CLASS () {
    return 'accordion-trigger'
  }

  get CONTENT_CLASS () {
    return 'accordion-content'
  }

  init () {
    const self = this

    this.elements.forEach(accordion => {
      const trigger = accordion.querySelector('.' + this.TRIGGER_CLASS)
      const content = accordion.querySelector('.' + this.CONTENT_CLASS)

      if (trigger && content) {
        trigger.addEventListener('click', evt => {
          self.toggle(trigger, content)
        })
      }
    })
  }

  toggle (trigger, content) {
    if (content.classList.contains(this.OPEN_CLASS)) {
      this._hide(trigger, content)
    } else {
      this._open(trigger, content)
    }
  }

  _open (trigger, content) {
    trigger.classList.add(this.OPEN_CLASS)
    content.classList.add(this.OPEN_CLASS)
  }

  _hide (trigger, content) {
    trigger.classList.remove(this.OPEN_CLASS)
    content.classList.remove(this.OPEN_CLASS)
  }
}
